

<div class="row mb-3" *ngIf="product.type.id === 'coping'">
    <div class="col-12 col-lg-4">
        <label class="app__label">
            Total length of wall
        </label>
    </div>
    <div class="col-12 col-lg-8">
        <div class="input-group">
            <input
                (focus)="triggerSetSubStep('wallLength')"
                (blur)="triggerClearSubStep()"
                type="number"
                min="1"
                class="form-control"
                [ngClass]="{'border-danger' : !product.quantity || product.quantity === 0}"
                [(ngModel)]="product.quantity"
                (ngModelChange)="updateLength()"/>
            <span class="input-group-text text-center w-25">Metres</span>
        </div>
        <div
            *ngIf="!product.quantity || product.quantity === 0"
            class="text-danger smallmt-3">
            The quantity must be at least 1
        </div>
    </div>
</div>

<div class="row mb-3" *ngIf="restrictions">
    <div class="col-12 col-lg-4">
        <label class="app__label">
            {{ product.type.id === 'coping' ? 'Coping width' : product.type.id === 'steps' ? 'Depth' : 'Width' }}
        </label>
    </div>
    <div class="col-12 col-lg-8">
        <div class="input-group">
            <input
                *ngIf="!product.widthRandom"
                (focus)="triggerSetSubStep('width')"
                (blur)="triggerClearSubStep()"
                type="number"
                class="form-control"
                min="{{restrictions.width.min}}"
                [ngClass]="{'border-danger' : product.width >= 0  && (product.width < restrictions.width.min || product.width > restrictions.width.max)}"
                [(ngModel)]="product.width"
                (ngModelChange)="calcBespokeCost()"/>
            <input
                (focus)="triggerSetSubStep('width')"
                (blur)="triggerClearSubStep()"
                *ngIf="product.widthRandom"
                type="text"
                value="Random"
                [disabled]="true"
                class="form-control">
            <span class="input-group-text text-center w-25">mm</span>
        </div>
        <div *ngIf="product.type.id === 'coping'" class="text-muted mt-3">
            Please allow for any overhang
        </div>
        <div
            *ngIf="product.width >= 0  && (product.width < restrictions.width.min || product.width > restrictions.width.max)"
            class="text-danger smallmt-3">
            Must be between {{restrictions.width.min}} and {{restrictions.width.max}}
        </div>
        <div *ngIf="product.type.allowRandomWidth" class="mt-3">
            <input (click)="widthRandom()" id="randomWidth" type="checkbox" class="custom-checkbox"
                   [checked]="product.widthRandom"/>
            <label class="fs-small" for="randomWidth">Prefer random width?</label>
        </div>

    </div>
</div>




<div class="row mb-3" *ngIf="restrictions">
    <div class="col-12 col-lg-4">
        <label class="app__label">
            {{ product.type.id === 'coping' ? 'Coping length' : product.type.id === 'steps' ? 'Width' : 'Length' }}
        </label>
    </div>
    <div *ngIf="product.lengthRandom || !product.lengthRandom" class="col-12 col-lg-8">
        <div class="input-group">
            <input
                *ngIf="!product.lengthRandom"
                (focus)="triggerSetSubStep('length')"
                (blur)="triggerClearSubStep()"
                type="number"
                min="1"
                class="form-control"
                [ngClass]="{
        'border-danger' : product.length >= 0
        && (product.length < restrictions.length.min || product.length > restrictions.length.max)}"
                [disabled]="product.lengthRandom"
                [(ngModel)]="product.length"
                (ngModelChange)="updateLength()"/>
            <input
                *ngIf="product.lengthRandom"
                (click)="timeoutTriggerSetSubStep('length')"
                type="text"
                class="form-control"
                value="Random"
                [disabled]="true"/>
            <span class="input-group-text text-center w-25">mm</span>
        </div>
        <div class="mt-3 text-danger small" *ngIf="product.length >= 0
    && (product.length < restrictions.length.min || product.length > restrictions.length.max)">
            Must be between {{restrictions.length.min}} and {{restrictions.length.max}}
        </div>
</div>
    <div *ngIf="product.type.allowRandomLength" class="col-12 col-lg-8">
        <div class="mt-3">
            <input (click)="lengthRandom()" id="randomLength" type="checkbox" class="custom-checkbox"
                   [checked]="product.lengthRandom"/>
            <label class="fs-small" for="randomLength">Prefer random lengths?</label>
        </div>

    </div>
</div>


<!-- <div class="row mb-3" *ngIf="product.type.id === 'steps'">
    <div class="col-12 col-lg-4">
        <label class="app__label">Width</label>
    </div>
    <div class="col-12 col-lg-4">

        <div class="input-group">
            <input
                *ngIf="!product.lengthRandom"
                (focus)="triggerSetSubStep('length')"
                (blur)="triggerClearSubStep()"
                type="number"
                min="1"
                class="form-control"
                [ngClass]="{
        'border-danger' : product.length >= 0
        && (product.length < restrictions.length.min)}"
                [disabled]="product.lengthRandom"
                [(ngModel)]="product.length"
                (ngModelChange)="updateLength()"/>
            <span *ngIf="!product.lengthRandom" class="input-group-text text-center w-25">mm</span>
            <div *ngIf="product.lengthRandom" (click)="timeoutTriggerSetSubStep('length')">
                <input
                    type="text"
                    class="form-control"
                    value="Random"
                    [disabled]="true"/>
            </div>
        </div>
        <div *ngIf="product.length >= 0 && (product.length < restrictions.length.min)"
             class="text-danger small mt-3">
            Must be over {{restrictions.length.min}}
        </div>
        <div *ngIf="product.type.allowRandomLength" class="mt-3">
            <input (click)="lengthRandom()" id="randomLengthSteps" type="checkbox" class="custom-checkbox"
                   [checked]="product.lengthRandom"/>
            <label class="fs-small" for="randomLengthSteps">Prefer random lengths?</label>
        </div>


    </div>
</div> -->



<div class="row mb-3" *ngIf="product.finish?.skuId !== 'RI'">
    <div class="col-12 col-lg-4">
        <label class="app__label">Thickness</label>
    </div>
    <div class="col-12 col-lg-8">
        <div class="input-group">
            <input
                type="number"
                min="1"
                class="form-control"
                (focus)="triggerSetSubStep('height')"
                (blur)="triggerClearSubStep()"
                [ngClass]="{'border-danger' : !heightValidation.valid}"
                [disabled]="product.finish?.skuId === 'RI' || this.product.weatheringRight > 0"
                [(ngModel)]="product.height"
                (ngModelChange)="validateHeight(); calcBespokeCost()"/>
            <span class="input-group-text text-center w-25">mm</span>
        </div>
        <div *ngIf="!heightValidation.valid" class="text-danger small mt-3">
            Must be between {{heightValidation.min}} and {{heightValidation.max}}
        </div>
        <div *ngIf="product.finish?.skuId === 'RI'" class="text-muted text-italic mt-3">
            *Thickness is as quarried
        </div>

    </div>
</div>


<div class="row mb-3" *ngIf="product.type.id === 'coping'">
    <div class="col-12 col-sm-6 col-md-4 col-xl-12">
        <label class="fw-bold mb-2">Total length of wall</label>
    </div>
    <div class="text-muted small">
        <ng-container *ngIf="product.type.id === 'coping'">
            The size for corner pieces will be calculated during masonry if
            selected. Please give the length of the single or multiple pieces required
        </ng-container>

        <ng-container>
            Please note there is a +/- 5mm tolerance for all sizes and thicknesses
        </ng-container>
    </div>

</div>


        <ng-container *ngIf="restrictions && product.type.id !== 'steps'
        && ((product.width >= restrictions.width.min && product.width <= restrictions.width.max)
        && (product.length >= restrictions.length.min && product.length <= restrictions.length.max) && validHeight)
        || restrictions && product.type.id === 'steps'
        && ((product.width >= restrictions.width.min && product.width <= restrictions.width.max)
        && (product.length >= restrictions.length.min) && validHeight)">

            <ng-container *ngIf="product.type.id === 'coping'">
                <div
                    class="alert alert-info mb-4">
                    <ng-container *ngIf="product.lengthRandom">
                        Your coping will comprise of {{product.quantity}} linear metres of random length coping
                        pieces
                    </ng-container>
                    <ng-container *ngIf="!product.lengthRandom">
                        Your coping will comprise of {{product.unitCostBreakdown.piecesRequired}} pieces
                        of {{product.length}}mm coping.
                        This totals
                        <span *ngIf="product.finish.id === 71">
                            {{(product.unitCostBreakdown.singlePieceSize * +product.unitCostBreakdown.piecesRequired) | number:'1.2-2'}}
                        </span>
                        <span *ngIf="product.finish.id === 72">
                            {{(product.unitCostBreakdown.singlePieceSize * +product.unitCostBreakdown.piecesRequired) | number:'1.2-2'}}
                        </span>
                        linear metres
                    </ng-container>
                </div>
            </ng-container>

            <ng-container *ngIf="product.type.id === 'steps' && product.length > restrictions.length.max">
                <div class="alert alert-info mb-4">
                    All steps over {{restrictions.length.max}}mm will be cut equally to the full width required.
                    This will
                    comprise of
                    {{this.div}} steps at approx {{ calcNoSteps(restrictions.length.max)}}mm
                </div>
            </ng-container>
        </ng-container>

        <div *ngIf="product.type && product.type.id !== 'coping'" class="row mb-4">
            <div class="col-12 col-lg-4">
                <label class="app__label" *ngIf="product.type.id !== 'steps'">Product Quantity</label>
                <label class="app__label" *ngIf="product.type.id === 'steps'">How many steps at the above dimensions?</label>
            </div>
            <div class="col-12 col-lg-8">
                <div class="input-group">
                    <input
                        type="number"
                        class="form-control"
                        (focus)="triggerSetSubStep('quantity')"
                        (blur)="triggerClearSubStep()"
                        [ngClass]="{'border-danger' : !product.quantity || product.quantity === 0}"
                        min="1"
                        [(ngModel)]="product.quantity"
                        (ngModelChange)="updateLength()"/>
                    <ng-container *ngIf="!product.type.allowPieces">
                        <span class="input-group-text">
                            {{product.type.description}}<span *ngIf="product.quantity > 1">s</span>
                        </span>
                    </ng-container>

                    <ng-container *ngIf="product.type.allowPieces">
                        <ng-select
                            [clearable]="false"
                            [searchable]="false"
                            [placeholder]="'Select unit size'"
                            (change)="setSellUnit($event)"
                            class="select-pieces dark"
                            [(ngModel)]="productQuantitySelected.name">
                            <!-- <ng-option *ngIf="product.sellUnits.length" [value]="''">Unit size</ng-option> -->

                            <ng-option
                                *ngFor="let sellUnit of product.sellUnits"
                                [value]="sellUnit">
                                {{sellUnit.name}}<ng-container *ngIf="product.quantity > 1">s</ng-container>
                            </ng-option>
                        </ng-select>
                    </ng-container>
                </div>
                <div
                    *ngIf="!product.quantity || product.quantity === 0"
                    class="text-danger smallmt-3">
                    The quantity must be at least 1
                </div>
            </div>

</div>
